export const API_URL =
  process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5001/api';

export const MAX_RUBRIC_SCORE = 200;
